'use client';
import dynamic from 'next/dynamic';

export { default as AddCircle } from './add-circle';
export { default as Add } from './add';
export { default as ArrowUp } from './arrow-up';
export { default as Awarded } from './awarded';
export { default as BarsCafes } from './bars-cafes';
export { default as Bed } from './bed';
export { default as Beverages } from './beverages';
export { default as Blog } from './blog';
export { default as CabineService } from './cabine-service';
export { default as Calendar } from './calendar';
export { default as CheckCircle } from './check-circle';
export { default as ChevronLeft } from './chevron-left';
export { default as ChevronRight } from './chevron-right';
export { default as Close } from './close';
export { default as Cocktails } from './cocktails';
export { default as Compare } from './compare';
export { default as Compass } from './compass';
export { default as Contact } from './contact';
export { default as Crew } from './crew';
export { default as DateRange } from './date-range';
export { default as DeleteIcon } from './delete-icon';
export { default as Departure } from './departure';
export { default as Destinations } from './destinations';
export { default as Diversity } from './diversity';
export { default as Done } from './done';
export { default as Edit } from './edit';
export { default as Editieren } from './editieren';
export { default as EisSpezialitaeten } from './eis-spezialitaeten';
export { default as Email } from './email';
export { default as Entertainment } from './entertainment';
export { default as Environment } from './environment';
export { default as Exklusivleistungen } from './exklusivleistungen';
export { default as ExpandLess } from './expand-less';
export { default as ExpandMore } from './expand-more';
export { default as Faq } from './faq';
export { default as FavoriteOutline } from './favorite-outline';
export { default as Favorite } from './favorite';
export { default as Favourite } from './favourite';
export { default as FilterList } from './filter-list';
export { default as Filter } from './filter';
export { default as Fleet } from './fleet';
export { default as FlexTimes } from './flex-times';
export { default as Group } from './group';
export { default as Harbor } from './harbor';
export { default as HighlightOff } from './highlight-off';
export { default as Home } from './home';
export { default as Hospitality } from './hospitality';
export { default as HowToReg } from './how-to-reg';
export { default as Info } from './info';
export { default as KabinenserviceIsKabine } from './kabinenservice-is-kabine';
export { default as Kaffeemaschine } from './kaffeemaschine';
export { default as KeyboardCapslock } from './keyboard-capslock';
export { default as KidsTeens } from './kids-teens';
export { default as Kontakt } from './kontakt';
export { default as Landing } from './landing';
export { default as Language } from './language';
export { default as LocationOn } from './location-on';
export { default as Login } from './login';
export { default as Logout } from './logout';
export { default as MeinSchiff1 } from './mein-schiff-1';
export { default as MeinSchiff2 } from './mein-schiff-2';
export { default as MeinSchiff3 } from './mein-schiff-3';
export { default as MeinSchiff4 } from './mein-schiff-4';
export { default as MeinSchiff5 } from './mein-schiff-5';
export { default as MeinSchiff6 } from './mein-schiff-6';
export { default as MeinSchiff7 } from './mein-schiff-7';
export { default as MeinSchiffAll } from './mein-schiff-all';
export { default as MeinSchiffHerz } from './mein-schiff-herz';
export { default as MeinSchiffRelax } from './mein-schiff-relax';
export { default as MeineReise } from './meine-reise';
export { default as MobileNavi } from './mobile-navi';
export { default as More } from './more';
export { default as Newsletter } from './newsletter';
export { default as Notifications } from './notifications';
export { default as Nussallergie } from './nussallergie';
export { default as Offer } from './offer';
export { default as OnSiteService } from './on-site-service';
export { default as Pai } from './pai';
export { default as Passenger } from './passenger';
export { default as People } from './people';
export { default as Percent } from './percent';
export { default as Person } from './person';
export { default as Print } from './print';
export { default as Profile } from './profile';
export { default as Ratings } from './ratings';
export { default as Refresh } from './refresh';
export { default as Reisedauer } from './reisedauer';
export { default as Relax } from './relax';
export { default as Remove } from './remove';
export { default as Report } from './report';
export { default as Roomsize } from './roomsize';
export { default as Search } from './search';
export { default as Services } from './services';
export { default as Settings } from './settings';
export { default as Shop } from './shop';
export { default as Sort } from './sort';
export { default as SpaFitness } from './spa-fitness';
export { default as SpecialEvents } from './special-events';
export { default as SpecialMoments } from './special-moments';
export { default as Sportkurse } from './sportkurse';
export { default as Ssl } from './ssl';
export { default as StarHalf } from './star-half';
export { default as StarOutline } from './star-outline';
export { default as Star } from './star';
export { default as Suitcase } from './suitcase';
export { default as Tariff } from './tariff';
export { default as TeeSpezialitaeten } from './tee-spezialitaeten';
export { default as TravelSearch } from './travel-search';
export { default as VisibilityOff } from './visibility-off';
export { default as Visibility } from './visibility';
export { default as WatchlistActive } from './watchlist-active';
export { default as Watchlist } from './watchlist';
export { default as Wetter } from './wetter';

export const dynamicComponents = {
  'add-circle': dynamic(() => import('./add-circle'), { ssr: false }),
  add: dynamic(() => import('./add'), { ssr: false }),
  'arrow-up': dynamic(() => import('./arrow-up'), { ssr: false }),
  awarded: dynamic(() => import('./awarded'), { ssr: false }),
  'bars-cafes': dynamic(() => import('./bars-cafes'), { ssr: false }),
  bed: dynamic(() => import('./bed'), { ssr: false }),
  beverages: dynamic(() => import('./beverages'), { ssr: false }),
  blog: dynamic(() => import('./blog'), { ssr: false }),
  'cabine-service': dynamic(() => import('./cabine-service'), { ssr: false }),
  calendar: dynamic(() => import('./calendar'), { ssr: false }),
  'check-circle': dynamic(() => import('./check-circle'), { ssr: false }),
  'chevron-left': dynamic(() => import('./chevron-left'), { ssr: false }),
  'chevron-right': dynamic(() => import('./chevron-right'), { ssr: false }),
  close: dynamic(() => import('./close'), { ssr: false }),
  cocktails: dynamic(() => import('./cocktails'), { ssr: false }),
  compare: dynamic(() => import('./compare'), { ssr: false }),
  compass: dynamic(() => import('./compass'), { ssr: false }),
  contact: dynamic(() => import('./contact'), { ssr: false }),
  crew: dynamic(() => import('./crew'), { ssr: false }),
  'date-range': dynamic(() => import('./date-range'), { ssr: false }),
  'delete-icon': dynamic(() => import('./delete-icon'), { ssr: false }),
  departure: dynamic(() => import('./departure'), { ssr: false }),
  destinations: dynamic(() => import('./destinations'), { ssr: false }),
  diversity: dynamic(() => import('./diversity'), { ssr: false }),
  done: dynamic(() => import('./done'), { ssr: false }),
  edit: dynamic(() => import('./edit'), { ssr: false }),
  editieren: dynamic(() => import('./editieren'), { ssr: false }),
  'eis-spezialitaeten': dynamic(() => import('./eis-spezialitaeten'), {
    ssr: false,
  }),
  email: dynamic(() => import('./email'), { ssr: false }),
  entertainment: dynamic(() => import('./entertainment'), { ssr: false }),
  environment: dynamic(() => import('./environment'), { ssr: false }),
  exklusivleistungen: dynamic(() => import('./exklusivleistungen'), {
    ssr: false,
  }),
  'expand-less': dynamic(() => import('./expand-less'), { ssr: false }),
  'expand-more': dynamic(() => import('./expand-more'), { ssr: false }),
  faq: dynamic(() => import('./faq'), { ssr: false }),
  'favorite-outline': dynamic(() => import('./favorite-outline'), {
    ssr: false,
  }),
  favorite: dynamic(() => import('./favorite'), { ssr: false }),
  favourite: dynamic(() => import('./favourite'), { ssr: false }),
  'filter-list': dynamic(() => import('./filter-list'), { ssr: false }),
  filter: dynamic(() => import('./filter'), { ssr: false }),
  fleet: dynamic(() => import('./fleet'), { ssr: false }),
  'flex-times': dynamic(() => import('./flex-times'), { ssr: false }),
  group: dynamic(() => import('./group'), { ssr: false }),
  harbor: dynamic(() => import('./harbor'), { ssr: false }),
  'highlight-off': dynamic(() => import('./highlight-off'), { ssr: false }),
  home: dynamic(() => import('./home'), { ssr: false }),
  hospitality: dynamic(() => import('./hospitality'), { ssr: false }),
  'how-to-reg': dynamic(() => import('./how-to-reg'), { ssr: false }),
  info: dynamic(() => import('./info'), { ssr: false }),
  'kabinenservice-is-kabine': dynamic(
    () => import('./kabinenservice-is-kabine'),
    { ssr: false },
  ),
  kaffeemaschine: dynamic(() => import('./kaffeemaschine'), { ssr: false }),
  'keyboard-capslock': dynamic(() => import('./keyboard-capslock'), {
    ssr: false,
  }),
  'kids-teens': dynamic(() => import('./kids-teens'), { ssr: false }),
  kontakt: dynamic(() => import('./kontakt'), { ssr: false }),
  landing: dynamic(() => import('./landing'), { ssr: false }),
  language: dynamic(() => import('./language'), { ssr: false }),
  'location-on': dynamic(() => import('./location-on'), { ssr: false }),
  login: dynamic(() => import('./login'), { ssr: false }),
  logout: dynamic(() => import('./logout'), { ssr: false }),
  'mein-schiff-1': dynamic(() => import('./mein-schiff-1'), { ssr: false }),
  'mein-schiff-2': dynamic(() => import('./mein-schiff-2'), { ssr: false }),
  'mein-schiff-3': dynamic(() => import('./mein-schiff-3'), { ssr: false }),
  'mein-schiff-4': dynamic(() => import('./mein-schiff-4'), { ssr: false }),
  'mein-schiff-5': dynamic(() => import('./mein-schiff-5'), { ssr: false }),
  'mein-schiff-6': dynamic(() => import('./mein-schiff-6'), { ssr: false }),
  'mein-schiff-7': dynamic(() => import('./mein-schiff-7'), { ssr: false }),
  'mein-schiff-all': dynamic(() => import('./mein-schiff-all'), { ssr: false }),
  'mein-schiff-herz': dynamic(() => import('./mein-schiff-herz'), {
    ssr: false,
  }),
  'mein-schiff-relax': dynamic(() => import('./mein-schiff-relax'), {
    ssr: false,
  }),
  'meine-reise': dynamic(() => import('./meine-reise'), { ssr: false }),
  'mobile-navi': dynamic(() => import('./mobile-navi'), { ssr: false }),
  more: dynamic(() => import('./more'), { ssr: false }),
  newsletter: dynamic(() => import('./newsletter'), { ssr: false }),
  notifications: dynamic(() => import('./notifications'), { ssr: false }),
  nussallergie: dynamic(() => import('./nussallergie'), { ssr: false }),
  offer: dynamic(() => import('./offer'), { ssr: false }),
  'on-site-service': dynamic(() => import('./on-site-service'), { ssr: false }),
  pai: dynamic(() => import('./pai'), { ssr: false }),
  passenger: dynamic(() => import('./passenger'), { ssr: false }),
  people: dynamic(() => import('./people'), { ssr: false }),
  percent: dynamic(() => import('./percent'), { ssr: false }),
  person: dynamic(() => import('./person'), { ssr: false }),
  print: dynamic(() => import('./print'), { ssr: false }),
  profile: dynamic(() => import('./profile'), { ssr: false }),
  ratings: dynamic(() => import('./ratings'), { ssr: false }),
  refresh: dynamic(() => import('./refresh'), { ssr: false }),
  reisedauer: dynamic(() => import('./reisedauer'), { ssr: false }),
  relax: dynamic(() => import('./relax'), { ssr: false }),
  remove: dynamic(() => import('./remove'), { ssr: false }),
  report: dynamic(() => import('./report'), { ssr: false }),
  roomsize: dynamic(() => import('./roomsize'), { ssr: false }),
  search: dynamic(() => import('./search'), { ssr: false }),
  services: dynamic(() => import('./services'), { ssr: false }),
  settings: dynamic(() => import('./settings'), { ssr: false }),
  shop: dynamic(() => import('./shop'), { ssr: false }),
  sort: dynamic(() => import('./sort'), { ssr: false }),
  'spa-fitness': dynamic(() => import('./spa-fitness'), { ssr: false }),
  'special-events': dynamic(() => import('./special-events'), { ssr: false }),
  'special-moments': dynamic(() => import('./special-moments'), { ssr: false }),
  sportkurse: dynamic(() => import('./sportkurse'), { ssr: false }),
  ssl: dynamic(() => import('./ssl'), { ssr: false }),
  'star-half': dynamic(() => import('./star-half'), { ssr: false }),
  'star-outline': dynamic(() => import('./star-outline'), { ssr: false }),
  star: dynamic(() => import('./star'), { ssr: false }),
  suitcase: dynamic(() => import('./suitcase'), { ssr: false }),
  tariff: dynamic(() => import('./tariff'), { ssr: false }),
  'tee-spezialitaeten': dynamic(() => import('./tee-spezialitaeten'), {
    ssr: false,
  }),
  'travel-search': dynamic(() => import('./travel-search'), { ssr: false }),
  'visibility-off': dynamic(() => import('./visibility-off'), { ssr: false }),
  visibility: dynamic(() => import('./visibility'), { ssr: false }),
  'watchlist-active': dynamic(() => import('./watchlist-active'), {
    ssr: false,
  }),
  watchlist: dynamic(() => import('./watchlist'), { ssr: false }),
  wetter: dynamic(() => import('./wetter'), { ssr: false }),
};
